const ProgressCircle = ({ visible, label, glyph, onClick }) => (
  <button
    type="button"
    className={visible ? 'progress-circle is-visible' : 'progress-circle'}
    aria-label={label}
    aria-hidden={visible ? undefined : true}
    tabIndex={visible ? 0 : -1}
    onClick={visible ? onClick : undefined}
  >
    {glyph === 'close' ? (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" />
      </svg>
    ) : (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 12h12M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" />
      </svg>
    )}
  </button>
);

export default ProgressCircle;
